import type { ReactNode } from 'react'

// FilterBar is the Trades-style full-width filter strip: gray background,
// bottom border, wrapping row of controls.
export function FilterBar({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-wrap items-center gap-2 border-b border-gray-200 bg-gray-50 px-4 py-3">{children}</div>
  )
}

export function FilterSearch({
  value,
  onChange,
  placeholder,
}: {
  value: string
  onChange: (v: string) => void
  placeholder?: string
}) {
  return (
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="w-44 rounded-md border border-gray-300 px-3 py-1.5 text-xs"
    />
  )
}

export function FilterClear({ onClick }: { onClick: () => void }) {
  return (
    <button onClick={onClick} className="px-2 py-1.5 text-xs text-gray-500 hover:text-gray-800">
      Clear filters
    </button>
  )
}
